<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İcra Dairesi</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="İcra Dairesi" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">IBAN</label>
            <v-validator :errors="errors" parameter="Iban" :watch="value.Iban">
                <input type="text" class="form-control" placeholder="IBAN" v-model="value.Iban">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap No</label>
            <v-validator :errors="errors" parameter="AccountNumber" :watch="value.AccountNumber">
                <input type="text" class="form-control" placeholder="Hesap No" v-model="value.AccountNumber">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Vergi Dairesi</label>
            <v-validator :errors="errors" parameter="TaxAdministrationId" :watch="taxAdministrator">
                <v-select-list v-model="taxAdministrator" :options="taxAdministrators" label="Name" placeholder="Vergi Dairesi"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Vergi Numarası</label>
            <v-validator :errors="errors" parameter="TaxNumber" :watch="value.TaxNumber">
                <input type="text" class="form-control" placeholder="Vergi Numarası" v-model="value.TaxNumber">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bank</label>
            <v-validator :errors="errors" parameter="Bank" :watch="bank">
                <v-select-list v-model="bank" :options="banks" label="BankName" placeholder="Bank"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="ProvinceId" :watch="province">
                <v-select-list v-model="province" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="İl"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İlçe</label>
            <v-validator :errors="errors" parameter="DistrictId" :watch="district">
                <v-select-list :disabled="!province" v-model="district" :options="districts" label="Name" placeholder="İlçe"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap Türü</label>
            <v-validator :errors="errors" parameter="LevyOfficeAccountType" :watch="type">
                <v-select-list v-model="type" :options="types" label="name" placeholder="Hesap Türü"></v-select-list>
            </v-validator>
        </div>
    </div>
</template>

<script>
import BankApi from '@/api/bank';
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getProvinces()
        this.getDistricts()
        this.getTaxAdministrators()
        this.getBanks()
    },
    data(){
        return {
            provinces:[],
            districts:[],
            taxAdministrators:[],
            banks:[],
            types:[
                {value:0,name:'Emanet'},
                {value:1,name:'Cezaevi'},
                {value:2,name:'Harç'}
            ]
        }
    },
    methods:{
        getProvinces(bool){
            if(bool){
                this.value.DistrictId = null
            }
            //TURKEY
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            if(this.value.ProvinceId){
                SystemDataApi.District(this.value.ProvinceId)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        },
        getTaxAdministrators(){
            SystemDataApi.TaxAdministrationList().then(res => {
                this.taxAdministrators = res.data.Data
            })
        },
        getBanks(){
            BankApi.List().then(res => {
                this.banks = res.data.Data
            })
        }
    },
    computed:{
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.CountryId)
            },
            set:function(value){
                this.value.CountryId = value?.Id || null
            }
        },
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.ProvinceId = value?.Id || null
            }
        },
        district:{
            get:function(){
                return this.districts.find(b=>b.Id==this.value.DistrictId)
            },
            set:function(value){
                this.value.DistrictId = value?.Id || null
            }
        },
        taxAdministrator:{
            get:function(){
                return this.taxAdministrators.find(b=>b.Id==this.value.TaxAdministrationId)
            },
            set:function(value){
                this.value.TaxAdministrationId = value?.Id || null
            }
        },
        bank:{
            get:function(){
                return this.banks.find(b=>b.Id==this.value.BankId)
            },
            set:function(value){
                this.value.BankId = value?.Id || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.value==this.value.LevyOfficeAccountType)
            },
            set:function(value){
                this.value.LevyOfficeAccountType = value?.value == null ? null : value.value
            }
        }
    }
}
</script>
